import { Box, Grid, Typography, Card, CardContent } from "@mui/material";
import React from "react";
import "./Numbers.css";
import { Images } from "../../../../helpers/Images";

const Numbers = () => {
  const stats = [
    { image: Images.team, number: "1250", title: "Team" },
    { image: Images.student, number: "6500", title: "Student" },
    { image: Images.academy, number: "190", title: "Academy/School" },
    { image: Images.category, number: "250", title: "Mentor" },
  ];

  return (
    <Box
      className="numbers-section"
      sx={{
        width: "100%",
        padding: { xs: "50px 20px", sm: "50px 60px", lg: "70px 120px" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: "#ffffff",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          maxWidth: "1400px",
          margin: "0 auto",
          width: "100%",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Typography
          variant="h2"
          className="numbers-title"
          sx={{
            textAlign: "center",
            fontSize: { xs: "32px", sm: "45px" },
            fontWeight: "700",
            color: "primary.darker",
            marginBottom: "12px",
            letterSpacing: "-0.5px",
          }}
        >
          IRC 2025 Numbers
        </Typography>
        <Box
          sx={{
            height: "4px",
            width: { xs: "120px", md: "180px" },
            background:
              "linear-gradient(90deg, transparent, #830d0b, transparent)",
            margin: "0 auto 24px auto",
            borderRadius: "2px",
            // boxShadow: "0 2px 8px rgba(131, 13, 11, 0.3)",
          }}
        />
        <Typography
          variant="body1"
          className="numbers-description"
          sx={{
            textAlign: "center",
            color: "rgba(0, 0, 0, 0.7)",
            maxWidth: "750px",
            margin: "0 auto 40px auto",
            fontSize: { xs: "15px", sm: "17px" },
            lineHeight: 1.5,
          }}
        >
          From the start in 2021 InternationalRobotChallenge® has grown fast,
          including more academies and more children and young people each year.
        </Typography>
        <Grid container spacing={{ xs: 3, sm: 4 }} justifyContent="center">
          {stats.map((item, index) => (
            <Grid item xs={6} sm={6} md={4} lg={2.4} key={index}>
              <Card
                className="stat-card"
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: { xs: "32px 20px" },
                  borderRadius: "20px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                  border: "1px solid rgba(131, 13, 11, 0.1)",
                  backgroundColor: "#ffffff",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  position: "relative",
                  overflow: "hidden",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "4px",
                    background: "linear-gradient(90deg, #830d0b, #ac1e1c)",
                    transform: "scaleX(0)",
                    transformOrigin: "left",
                    transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  },
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: "0 12px 32px rgba(131, 13, 11, 0.15)",
                    borderColor: "primary.main",
                    "&::before": {
                      transform: "scaleX(1)",
                    },
                    "& .stat-icon": {
                      transform: "scale(1.1) rotate(5deg)",
                    },
                    "& .stat-number": {
                      transform: "scale(1.1)",
                      color: "primary.main",
                    },
                  },
                }}
              >
                <Box
                  className="stat-icon-wrapper"
                  sx={{
                    width: { xs: "70px", sm: "80px" },
                    height: { xs: "70px", sm: "80px" },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "20px",
                    position: "relative",
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                      background:
                        "linear-gradient(135deg, rgba(131, 13, 11, 0.1), rgba(172, 30, 28, 0.05))",
                      opacity: 0,
                      transition: "opacity 0.4s ease",
                    }}
                    className="stat-icon-bg"
                  />
                  <img
                    src={item.image}
                    alt={item.title}
                    className="stat-icon"
                    style={{
                      height: "100%",
                      width: "auto",
                      filter:
                        "invert(13%) sepia(48%) saturate(5796%) hue-rotate(350deg) brightness(103%) contrast(93%)",
                      transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                      position: "relative",
                      zIndex: 1,
                    }}
                  />
                </Box>
                <CardContent
                  sx={{
                    padding: "0 !important",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Typography
                    className="stat-number"
                    variant="h3"
                    sx={{
                      fontSize: { xs: "36px", sm: "42px", md: "48px" },
                      fontWeight: "800",
                      color: "primary.darker",
                      marginBottom: "8px",
                      lineHeight: 1,
                      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                      letterSpacing: "-1px",
                    }}
                  >
                    {item.number}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: { xs: "14px", sm: "16px" },
                      fontWeight: "600",
                      color: "primary.light",
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                    }}
                  >
                    {item.title}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Numbers;

// RobotChallenge is one of the biggest competitions for self-made, autonomous and mobile robots worldw
